<ng-container *ngIf="loading">
  <div class="loading-bar">
    <tm1-progress-ring value="" min="0" max="1" size="regular"></tm1-progress-ring>
  </div>
</ng-container>

<app-big-screen-dashboard
  [open]="bigScreenOpen"
  [useDarkMode]="useDarkMode"
  [attendanceSummary]="attendanceSummary"
  [venueKey]="Selectedvenue"
  [venueName]="venueValue?.name || ''"
  [timedGateEntries]="timedGateEntries"
  [timedScannerEntries]="timedScannerEntries"
  [chartColors]="chartColors"
  (closed)="closeBigScreen()">
</app-big-screen-dashboard>

<ng-container *ngIf="isModalOpen">
  <div class="modal">
    <tm1-card class="modal-content">
      <span class="close" (click)="closeModal()">&times;</span>
      <tm1-typography type="data-l">Share Link</tm1-typography>
      <br />
      <tm1-typography type="data-s">The below link can be shared with any external user without the need to
        login</tm1-typography>
      <br />
      <tm1-typography type="data-s">Anyone who has access this link will be able to view the attendance results for the
        given report for the next 24 hours </tm1-typography>
      <br />
      <tm1-tooltip anchor="copy" position="bottom">Click to copy share link for current report</tm1-tooltip>
      <tm1-text-field appearance="outline" label="Share Link" placeholder="Generating....."
        value="{{shareLink}}"></tm1-text-field>
      <img style="color: blue;" class="download-icon" (click)="copyLink();" id="copy"
        src="../../assets/content_copy_24dp_026CDF_FILL0_wght400_GRAD0_opsz24.png" alt="Share Icon">
    </tm1-card>
  </div>
</ng-container>

<ng-container *ngIf="isScheduleModalOpen">
  <div class="modal">
    <tm1-card class="modal-content schedule-modal-content">
      <span class="close" (click)="closeScheduleModal()">&times;</span>

      <tm1-typography type="data-l">Scheduled Email Reports</tm1-typography>
      <br />

      <!-- Date picker (always visible) -->
      <div class="schedule-date-row">
        <tm1-typography type="data-s"><strong>Report date</strong></tm1-typography>
        <input type="date" class="form-control schedule-date-input" [(ngModel)]="scheduleDate"
          [min]="currentDate" (change)="onScheduleDateChange()" />
      </div>
      <br />

      <!-- Loading -->
      <ng-container *ngIf="scheduleLoading">
        <tm1-progress-ring value="" min="0" max="1" size="regular"></tm1-progress-ring>
      </ng-container>

      <!-- ========== LIST VIEW ========== -->
      <ng-container *ngIf="!scheduleLoading && !scheduleEditMode">

        <ng-container *ngIf="allSchedules.length">
          <div class="schedule-list-heading">
            <tm1-typography type="data-s"><strong>Active schedules for {{ scheduleDate }}</strong></tm1-typography>
            <tm1-icon icon="info" id="schedule-info" style="font-size: 18px; cursor: pointer;"></tm1-icon>
            <tm1-tooltip anchor="schedule-info" position="right">Click a row to edit that schedule</tm1-tooltip>
          </div>
          <div class="schedule-table-wrapper">
            <table class="schedule-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Schedule</th>
                  <th>Window</th>
                  <th>Recipients</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of allSchedules" class="schedule-row-clickable"
                  [class.schedule-row-mine]="s.userID === currentUserID"
                  (click)="selectSchedule(s)">
                  <td>{{ s.name || '—' }}</td>
                  <td>
                    <ng-container *ngIf="s.sendType === 'fixed'">Once at {{ s.sendTime }}</ng-container>
                    <ng-container *ngIf="s.sendType !== 'fixed'">Every {{ s.frequency }} min</ng-container>
                  </td>
                  <td>
                    <ng-container *ngIf="s.sendType === 'fixed'">—</ng-container>
                    <ng-container *ngIf="s.sendType !== 'fixed'">
                      <ng-container *ngIf="s.startTime || s.endTime">
                        {{ s.startTime || '--' }} - {{ s.endTime || '--' }}
                      </ng-container>
                      <ng-container *ngIf="!s.startTime && !s.endTime">All day</ng-container>
                    </ng-container>
                  </td>
                  <td>{{ s.emailList?.join(', ') }}</td>
                  <td class="schedule-delete-cell">
                    <button class="schedule-delete-btn" type="button"
                      (click)="$event.stopPropagation(); deleteSchedule(s.scheduleId)">&#10005;</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
        </ng-container>

        <ng-container *ngIf="!allSchedules.length">
          <tm1-typography type="data-s" style="color: #888;">No schedules configured for {{ scheduleDate }}.</tm1-typography>
          <br /><br />
        </ng-container>

        <tm1-button variant="solid" color="primary" type="button" (click)="startNewSchedule()">
          New Schedule
        </tm1-button>
      </ng-container>

      <!-- ========== EDIT VIEW ========== -->
      <ng-container *ngIf="!scheduleLoading && scheduleEditMode">

        <div class="schedule-edit-header">
          <button class="schedule-back-btn" type="button" (click)="backToList()">&#8592; Back to List</button>
        </div>
        <br />

        <tm1-typography type="data-s"><strong>Label (optional)</strong></tm1-typography>
        <br />
        <input type="text" class="form-control" maxlength="100"
          placeholder="e.g. Gate Ops Morning" [(ngModel)]="scheduleName" />
        <br /><br />

        <tm1-typography type="data-s"><strong>Schedule type</strong></tm1-typography>
        <br />
        <select class="form-control" [(ngModel)]="scheduleSendType">
          <option value="interval">Send repeatedly on an interval</option>
          <option value="fixed">Send once at a fixed time</option>
        </select>
        <br /><br />

        <!-- Interval schedule fields -->
        <ng-container *ngIf="scheduleSendType === 'interval'">
          <tm1-typography type="data-s"><strong>Send frequency</strong></tm1-typography>
          <br />
          <select class="form-control" [(ngModel)]="scheduleFrequency">
            <option *ngFor="let opt of scheduleFrequencyOptions" [ngValue]="opt">Every {{ opt }} minutes</option>
          </select>
          <br /><br />

          <tm1-typography type="data-s"><strong>Time window (optional, venue local time)</strong></tm1-typography>
          <br />
          <div class="schedule-time-row">
            <div class="schedule-time-field">
              <label>Start time</label>
              <input type="time" class="form-control" [(ngModel)]="scheduleStartTime" />
            </div>
            <div class="schedule-time-field">
              <label>End time</label>
              <input type="time" class="form-control" [(ngModel)]="scheduleEndTime" />
            </div>
          </div>
          <br />
        </ng-container>

        <!-- Fixed schedule field -->
        <ng-container *ngIf="scheduleSendType === 'fixed'">
          <tm1-typography type="data-s"><strong>Send time (venue local time, 5-minute boundary)</strong></tm1-typography>
          <br />
          <div class="schedule-time-row">
            <div class="schedule-time-field">
              <label>Send at</label>
              <input type="time" class="form-control" step="300" [(ngModel)]="scheduleSendTime" />
            </div>
          </div>
          <br />
        </ng-container>

        <tm1-typography type="data-s"><strong>Recipients</strong></tm1-typography>
        <br />
        <div class="schedule-email-list">
          <span class="schedule-email-tag" *ngFor="let email of scheduleEmails">
            {{ email }}
            <span class="schedule-email-remove" (click)="removeScheduleEmail(email)">&times;</span>
          </span>
        </div>
        <br />
        <div class="schedule-email-add-row">
          <textarea class="form-control schedule-email-textarea" rows="3"
            placeholder="Enter email addresses (one per line or comma-separated)"
            [(ngModel)]="scheduleEmailInput"></textarea>
          <tm1-button type="button" (click)="addScheduleEmails()">Add</tm1-button>
        </div>
        <br />

    
        <ng-container *ngIf="scheduleError">
          <tm1-typography type="data-s" style="color: #d32f2f;">{{ scheduleError }}</tm1-typography>
          <br />
        </ng-container>
        <ng-container *ngIf="scheduleSuccess">
          <tm1-typography type="data-s" style="color: #388e3c;">{{ scheduleSuccess }}</tm1-typography>
          <br />
        </ng-container>

        <!-- Action buttons -->
        <div class="schedule-actions">
          <tm1-button color="positive" type="button" (click)="saveSchedule()">
            {{ isExistingScheduleSelected() ? 'Update Schedule' : 'Create Schedule' }}
          </tm1-button>
          <ng-container *ngIf="isExistingScheduleSelected()">
            <tm1-button  color="caution" type="button" (click)="toggleCopyDatePicker()">
              Copy to New Date
            </tm1-button>
            <tm1-button  color="negative" type="button" (click)="deleteSchedule()">
              Delete Schedule
            </tm1-button>
          </ng-container>
        </div>

        <!-- Copy to date picker -->
        <ng-container *ngIf="showCopyDatePicker">
          <br />
          <div class="schedule-copy-row">
            <tm1-typography type="data-s">Copy schedule to:</tm1-typography>
            <input type="date" class="form-control schedule-date-input" [(ngModel)]="copyToDate"
              [min]="currentDate" />
            <tm1-button variant="solid" color="primary" type="button" (click)="copyScheduleToDate()">Copy</tm1-button>
          </div>
        </ng-container>
      </ng-container>
    </tm1-card>
  </div>
</ng-container>

<ng-container *ngIf="isManageSessionsModalOpen">
  <div class="modal">
    <tm1-card class="modal-content manage-sessions-modal-content">
      <span class="close" (click)="closeManageSessionsModal()">&times;</span>

      <h2 class="manage-sessions-title">Manage Sessions</h2>

      <p class="manage-sessions-description">
        Sessions split a venue's day into named time windows (e.g. matinee and evening
        performances). Each scan that occurs between a session's start and end times is
        counted towards that session, in addition to the full-day total. Once saved,
        sessions appear in the report selector alongside <em>Full Day Report</em> so you
        can view attendance for just that window.
      </p>

      <div class="manage-sessions-date-row">
        <label class="manage-sessions-label">Date</label>
        <input type="date" class="form-control schedule-date-input"
          [(ngModel)]="manageSessionsDate" (change)="onManageSessionsDateChange()" />
      </div>

      <ng-container *ngIf="manageSessionsLoading">
        <tm1-progress-ring value="" min="0" max="1" size="regular"></tm1-progress-ring>
      </ng-container>

      <ng-container *ngIf="!manageSessionsLoading">
        <datalist id="manage-sessions-time-presets">
          <option *ngFor="let t of manageSessionsTimePresets" [value]="t"></option>
        </datalist>

        <h3 class="manage-sessions-subtitle">Existing sessions</h3>
        <div class="schedule-table-wrapper">
          <table class="schedule-table manage-sessions-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Start</th>
                <th>End</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of manageSessionsList">
                <td>
                  <input class="form-control" type="text" [(ngModel)]="s.name" />
                </td>
                <td>
                  <input class="form-control" type="time" list="manage-sessions-time-presets"
                    [(ngModel)]="s.startTime" />
                </td>
                <td>
                  <input class="form-control" type="time" list="manage-sessions-time-presets"
                    [(ngModel)]="s.endTime" />
                </td>
                <td class="schedule-delete-cell">
                  <button class="schedule-delete-btn" type="button"
                    (click)="removeManageSession(s.key)">&#10005;</button>
                </td>
              </tr>
              <tr *ngIf="!manageSessionsList.length">
                <td colspan="4" class="manage-sessions-empty">No sessions configured for {{ manageSessionsDate }}.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="manage-sessions-subtitle">Add session</h3>
        <div class="manage-sessions-add-row">
          <div class="manage-sessions-field manage-sessions-field-name">
            <label class="manage-sessions-field-label">Name</label>
            <input class="form-control manage-sessions-name-input" type="text" placeholder="e.g. Matinee"
              [(ngModel)]="manageSessionsNewName" />
          </div>
          <div class="manage-sessions-field">
            <label class="manage-sessions-field-label">Start</label>
            <input class="form-control manage-sessions-time-input" type="time"
              list="manage-sessions-time-presets"
              [(ngModel)]="manageSessionsNewStart" />
          </div>
          <div class="manage-sessions-field">
            <label class="manage-sessions-field-label">End</label>
            <input class="form-control manage-sessions-time-input" type="time"
              list="manage-sessions-time-presets"
              [(ngModel)]="manageSessionsNewEnd" />
          </div>
          <tm1-button class="manage-sessions-add-btn" type="button" (click)="addManageSession()">Add</tm1-button>
        </div>

        <ng-container *ngIf="manageSessionsError">
          <p class="manage-sessions-message manage-sessions-error">{{ manageSessionsError }}</p>
        </ng-container>
        <ng-container *ngIf="manageSessionsSuccess">
          <p class="manage-sessions-message manage-sessions-success">{{ manageSessionsSuccess }}</p>
        </ng-container>

        <div class="schedule-actions">
          <tm1-button color="positive" type="button" [disabled]="manageSessionsSaving"
            (click)="saveManageSessions()">
            {{ manageSessionsSaving ? 'Saving…' : 'Save Sessions' }}
          </tm1-button>
        </div>
      </ng-container>
    </tm1-card>
  </div>
</ng-container>

<!-- <ng-container *ngIf="isSessionModalOpen">
    <div class="modal">
      <tm1-card class="modal-content">
        <span class="close" (click)="closeModal()">&times;</span>
        <tm1-typography type="data-l">Sessions</tm1-typography>
        <br/>
        <ng-container *ngIf = "sessions">
        <tm1-typography type="data-s">Below is a list of the sessions that are currently set up for this venue and date</tm1-typography>
        <br/>
              <li *ngFor="let session of sessions" [value]="session.key">
                {{ session.name }}
                {{ (+session.startEpoch * 1000) | date:'shortTime' }} to {{ (+session.endEpoch * 1000) | date:'shortTime' }}
              </li>
        </ng-container>
        <br/>
        <tm1-typography type="data-s">If you would like to add a session please submit the form below: </tm1-typography>
        <br/>
  lol
      </tm1-card>
    </div>
    </ng-container> -->

<div class="topborder">

  <app-venue-selector
    [venues]="venuelist"
    [activeVenueKeys]="activeVenueKeys"
    [(selectedKey)]="Selectedvenue"
    (venueSelected)="onVenueChange()"
  ></app-venue-selector>

  <div class="topborder-date-row">
    <ng-container *ngIf="!dateRange">
      <input [(ngModel)]="date" type="date" id="start" name="trip-start" value="{{date}}" [max]="currentDate"
        class="form-control" (change)="onDateChange()" />

      <ng-container *ngIf="sessions">
        <div class="custom-select-wrapper">
          <span class="select-sizer" aria-hidden="true">{{ selectedSessionLabel }}</span>
          <select (change)="onSessionChange($event);" class="form-control custom-select">
            <option value="All">Full Day Report</option>
            <option *ngFor="let session of sessions" [value]="session.key">
              {{ session.name }}
            </option>
          </select>
        </div>
      </ng-container>

      <tm1-icon class="refresh" icon="refresh" (click)="getVenueAttendance()">
      </tm1-icon>
      <ng-container *ngIf="ticketmaster | async">
        <tm1-icon class="refresh manage-sessions-icon" icon="add" id="manage-sessions"
          (click)="openManageSessionsModal()"></tm1-icon>
        <tm1-tooltip anchor="manage-sessions" position="bottom">Manage sessions</tm1-tooltip>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="dateRange">
      <input [(ngModel)]="date" (change)="onDateChange()" type="date" id="start" name="trip-start" value=""
        max="{{endDate}}" class=" date a form-control" />

      <input [(ngModel)]="endDate" (change)="onEndDateChange()" type="date" id="start" name="trip-start"
        value="{{endDate}}" max="{{currentDate}}" class=" date a form-control" />
      <tm1-icon class="refresh" icon="refresh" color="#060606" style="fill: rgb(6, 6, 6);" id="refresh"
        (click)="getVenueAttendance()" color="blue"></tm1-icon>
      <ng-container *ngIf="ticketmaster | async">
        <tm1-icon class="refresh manage-sessions-icon" icon="add" id="manage-sessions-range"
          (click)="openManageSessionsModal()"></tm1-icon>
        <tm1-tooltip anchor="manage-sessions-range" position="bottom">Manage sessions</tm1-tooltip>
      </ng-container>
    </ng-container>

    <button class="action-menu-burger" type="button" (click)="toggleActionMenu()"
      [class.open]="actionMenuOpen" aria-label="Open actions menu">
      <span></span><span></span><span></span>
    </button>

    <div class="action-menu-backdrop" *ngIf="actionMenuOpen" (click)="closeActionMenu()"></div>

    <div class="action-icons" [class.open]="actionMenuOpen">
      <button class="action-item" type="button"
        (click)="getVenueAttendance(); closeActionMenu()">
        <tm1-icon class="action-tm-icon" icon="refresh"></tm1-icon>
        <span class="action-label">Refresh</span>
      </button>

      <button class="action-item" type="button"
        *ngIf="ticketmaster | async"
        (click)="openManageSessionsModal(); closeActionMenu()">
        <tm1-icon class="action-tm-icon" icon="add"></tm1-icon>
        <span class="action-label">Manage sessions</span>
      </button>

      <button class="action-item" type="button"
        (click)="toggleDateRange(); closeActionMenu()">
        <tm1-icon class="action-tm-icon" [icon]="dateRange ? 'check' : 'calendar'"></tm1-icon>
        <span class="action-label">{{ dateRange ? 'Single date' : 'Search date range' }}</span>
      </button>
    </div>
  </div>

  <tm1-checkbox class="dateRangeCheck" (change)="selectDateRangeChangeHandler($event)" error="" size="medium"
    [checked]="toggleDateRangeCheckBox()" value="">
    Search Date Range
  </tm1-checkbox>

  <span class="tm-logo" role="img" aria-label="Ticketmaster"></span>
</div>

<div class="container">
  <ng-container *ngIf="displayData">
    <div class="header-container" *ngIf="!useModernView">
      <tm1-typography class="card-title" type="subheading-s">VENUE SCAN TOTALS</tm1-typography>

      <img id="download" class="download-icon" (click)="downloadSummaryCSV()"
        src="../../../assets/download_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.png" alt="Download Icon" />
      <tm1-tooltip anchor="download" position="bottom">Download Excel file containing current attendance results</tm1-tooltip>

      <img class="download-icon" (click)="openModal()" id="share"
        src="../../../assets/share_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.png" alt="Share Icon">
      <tm1-tooltip anchor="share" position="bottom">Click to copy share link for current report</tm1-tooltip>

      <img class="download-icon" (click)="sendEmail()" id="email"
        src="../../../assets/forward_to_inbox_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.png" alt="Email Icon">

      <img class="download-icon" (click)="openScheduleModal()" id="schedule-send"
        src="../../../assets/schedule_send_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.svg" alt="Schedule Send Icon">
      <tm1-tooltip anchor="schedule-send" position="bottom">Manage scheduled email reports</tm1-tooltip>
    </div>
    <br />
    <ng-container *ngIf="!useModernView">
      <tm1-badge class="attendanceBadge" appearance="accent" baseColor="new" circular="True">
        <th>
          <ng-container *ngIf="!dateRange">
            Attendance on {{ date }} {{LiveDate}}
          </ng-container>
          <ng-container *ngIf="dateRange">
            Attendance from {{ date }} to {{ endDate }}
          </ng-container>
        </th>
      </tm1-badge>
      <br />
    </ng-container>
    <ng-container *ngIf="SelectedSession !== ''">
      <ng-container *ngIf="selectedSessionTime as session">
        <tm1-badge class="attendanceBadge" appearance="accent" baseColor="new" circular="True">
          <ng-container *ngIf="session?.startEpoch">{{ (+session.startEpoch * 1000) | date:'shortTime' }} to {{
            (+session.endEpoch * 1000) | date:'shortTime' }}</ng-container>
        </tm1-badge>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="SelectedSession === ''"></ng-container>
    <br />
    <app-modern-summary *ngIf="useModernView"
      [attendanceSummary]="attendanceSummary"
      [venueName]="venueValue?.name || ''"
      [date]="date"
      [endDate]="endDate"
      [dateRange]="dateRange"
      [liveDate]="LiveDate"
      [venueTimezone]="venueTimezone"
      [useDarkMode]="useDarkMode"
      [stopDataToggle]="stopDataToggle"
      [liveButton]="liveButton"
      [fireworkIntensity]="fireworkIntensity"
      [fireworkLabel]="fireworkLabel"
      [showErrorBreakdown]="(ticketmaster | async) ?? false"
      [allowEntranceGrouping]="true"
      [venueKey]="Selectedvenue"
      (download)="downloadSummaryCSV()"
      (share)="openModal()"
      (email)="sendEmail()"
      (schedule)="openScheduleModal()"
      (pause)="stopData()"
      (play)="liveData()"
      (darkModeToggle)="setDarkMode($event)"
      (openBigScreen)="openBigScreen()">
    </app-modern-summary>

    <div class="card-container" *ngIf="!useModernView">
      <tm1-card variant="shadow" class="card-main">
        <ng-contatiner *ngIf="stopDataToggle">
          <div class=liveContainer>
            <tm1-icon class="liveIcon" icon="pause" id="pause" (click)=stopData() color="#f40c0c"
              style="fill: rgb(244, 12, 12);"></tm1-icon>
            <tm1-tooltip anchor="pause" position="bottom">Pause live data refresh</tm1-tooltip>
            <div class="spinner-container">
              <circle-progress [percent]="50" [radius]="15" [outerStrokeWidth]="5" [outerStrokeColor]="'#026CDF'"
                [innerStrokeWidth]="0" [showUnits]="false" [showTitle]="false"></circle-progress>
              <img class="center-image" src="../../assets/Ticketmaster-Emblem.png" alt="" />
            </div>
          </div>
        </ng-contatiner>
        <ng-contatiner *ngIf="liveButton">
          <div class=liveContainer>
            <tm1-icon class="liveIcon" icon="play" (click)=liveData() id="play" color="green"></tm1-icon>
            <tm1-tooltip anchor="play" position="bottom">Resume live data refresh</tm1-tooltip>
            <div class="spinner-container">
              <circle-progress [percent]="100" [radius]="15" [outerStrokeWidth]="5" [outerStrokeColor]="'#026CDF'"
                [innerStrokeWidth]="0" [showUnits]="false" [showTitle]="false"></circle-progress>
              <img class="center-image" src="../../assets/Ticketmaster-Emblem.png" alt="" />
            </div>
          </div>
        </ng-contatiner>
        <div class="top-content">
          <tm1-typography class="card-heading" type="subheading-m">FANS INSIDE</tm1-typography>
          <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.inVenue}}</tm1-typography>
          <tm1-typography class="card-heading" type="subheading-m">FANS ENTERED</tm1-typography>
          <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.entries}}</tm1-typography>
          <tm1-typography class="card-heading" type="subheading-m">FANS EXITED</tm1-typography>
          <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.exits}}</tm1-typography>
        </div>
        <div class="bottom-content">
          <div class="vertical-stack">
            <tm1-typography class="card-heading" type="subheading-m">Entries</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.entries}}</tm1-typography>
          </div>
          <div class="vertical-stack">
            <tm1-typography class="card-heading" type="subheading-m">Exits</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.exits}}</tm1-typography>
          </div>
          <div class="vertical-stack">
            <tm1-typography class="card-heading" type="subheading-m">Internal</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.internal}}</tm1-typography>
          </div>
          <div class="vertical-stack">
            <tm1-typography class="card-heading" type="subheading-m">Reentries</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{attendanceSummary.reentries}}</tm1-typography>
          </div>
        </div>
      </tm1-card>
    </div>
    <ng-container *ngIf="entranceGroupTable !== undefined && !useModernView">
      <tm1-typography class="card-title" type="subheading-m">GROUPED ENTRANCE SCAN TOTALS</tm1-typography>
      <div class="card-container">
        <ng-container *ngFor="let key of venue.objectKeys(attendanceSummary.groupedEntries)">
          <tm1-card class="card">
            <tm1-typography class="card-heading" type="subheading-m">Group Name</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{ key }}</tm1-typography>
            <tm1-typography class="card-heading" type="subheading-m">Entries</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{
              attendanceSummary.groupedEntries[key].entries}}</tm1-typography>
            <tm1-typography class="card-heading" type="subheading-m">Exits</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{
              attendanceSummary.groupedEntries[key].exits}}</tm1-typography>
            <tm1-typography class="card-heading" type="subheading-m">Internal</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{
              attendanceSummary.groupedEntries[key].internal}}</tm1-typography>
            <tm1-typography class="card-heading" type="subheading-m">Reentries</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{
              attendanceSummary.groupedEntries[key].reentries}}</tm1-typography>
            <tm1-typography class="card-heading" type="subheading-m">Inside</tm1-typography>
            <tm1-typography class="card-result" type="subheading-m">{{ attendanceSummary.groupedEntries[key].entries -
              attendanceSummary.groupedEntries[key].exits + attendanceSummary.groupedEntries[key].reentries
              }}</tm1-typography>
          </tm1-card>
        </ng-container>
      </div>
    </ng-container>
    <div class="extended-summary-section" [class.dark]="useModernView && useDarkMode">
      <div class="extended-summary-heading">
        <span>Extended Reporting</span>
      </div>
      <div class="extended-summary-buttons">
        <button class="extended-summary-button" type="button"
          [class.active]="showSummary" (click)="toggleTable('showSummary')">Venue Totals</button>
        <button class="extended-summary-button" type="button"
          *ngIf="entranceGroupTable !== undefined"
          [class.active]="showGroup" (click)="toggleTable('showGroup')">Grouped Entrances</button>
        <button class="extended-summary-button" type="button"
          [class.active]="showEntrance" (click)="toggleTable('showEntrance')">Entrances</button>
        <button class="extended-summary-button" type="button"
          [class.active]="showEvent" (click)="toggleTable('showEvent')">Events</button>
        <button class="extended-summary-button" type="button"
          [class.active]="showTicket" (click)="toggleTable('showTicket')">Ticket Types</button>
        <button class="extended-summary-button" type="button"
          [class.active]="showGraph" (click)="toggleTable('showGraph')">Graphs</button>
      </div>
    </div>
    <ng-container *ngIf="showEntrance">
      <div class="extended-summary-table-wrapper" [class.dark]="useModernView && useDarkMode">
        <table class="extended-summary-table">
          <thead>
            <tr>
              <th class="sortable" (click)="toggleSort('entrances', 'name')">Gate Name <span class="sort-indicator">{{ sortIndicator('entrances', 'name') }}</span></th>
              <th class="sortable" (click)="toggleSort('entrances', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('entrances', 'entries') }}</span></th>
              <th class="sortable" (click)="toggleSort('entrances', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('entrances', 'exits') }}</span></th>
              <th class="sortable" (click)="toggleSort('entrances', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('entrances', 'internal') }}</span></th>
              <th class="sortable" (click)="toggleSort('entrances', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('entrances', 'reentries') }}</span></th>
              <th class="sortable" (click)="toggleSort('entrances', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('entrances', 'inVenue') }}</span></th>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.entrances.length">
                <th class="reject-col reject-pct-col sortable" (click)="toggleSort('entrances', '__rejectPct')">Reject % <span class="sort-indicator">{{ sortIndicator('entrances', '__rejectPct') }}</span></th>
                <th class="reject-col reject-total-col sortable"
                  [class.expanded]="rejectsExpanded.entrances"
                  title="Click to {{ rejectsExpanded.entrances ? 'hide' : 'show' }} reject breakdown">
                  <span class="reject-total-label" (click)="toggleSort('entrances', '__rejectTotal'); $event.stopPropagation()">
                    Rejects
                    <span class="sort-indicator">{{ sortIndicator('entrances', '__rejectTotal') }}</span>
                  </span>
                  <span class="reject-toggle-arrow" (click)="toggleRejectsExpanded('entrances'); $event.stopPropagation()">
                    {{ rejectsExpanded.entrances ? '▾' : '▸' }}
                  </span>
                </th>
                <ng-container *ngIf="rejectsExpanded.entrances">
                  <th class="reject-col sortable" *ngFor="let code of rejectColumnsByTable.entrances"
                    (click)="toggleSort('entrances', '__reject:' + code)">
                    {{ formatErrorCode(code) }} <span class="sort-indicator">{{ sortIndicator('entrances', '__reject:' + code) }}</span>
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of sortedEntranceKeysCache">
              <td class="primary-cell">{{ key }}</td>
              <td>{{ attendanceSummary.entrances[key].entries }}</td>
              <td>{{ attendanceSummary.entrances[key].exits }}</td>
              <td>{{ attendanceSummary.entrances[key].internal }}</td>
              <td>{{ attendanceSummary.entrances[key].reentries }}</td>
              <td>{{ attendanceSummary.entrances[key].inVenue }}</td>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.entrances.length">
                <td class="reject-col reject-pct-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.entrances[key].rejects)">
                  {{ rejectPercent(attendanceSummary.entrances[key]) | number: '1.0-2' }}%
                </td>
                <td class="reject-col reject-total-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.entrances[key].rejects)">
                  {{ rejectTotal(attendanceSummary.entrances[key].rejects) }}
                </td>
                <ng-container *ngIf="rejectsExpanded.entrances">
                  <td class="reject-col" *ngFor="let code of rejectColumnsByTable.entrances"
                    [class.is-zero]="!rejectCount(attendanceSummary.entrances[key].rejects, code)">
                    {{ rejectCount(attendanceSummary.entrances[key].rejects, code) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container *ngIf="showEvent">
      <div class="extended-summary-table-wrapper" [class.dark]="useModernView && useDarkMode">
        <table class="extended-summary-table">
          <thead>
            <tr>
              <th class="sortable" (click)="toggleSort('events', 'name')">Event Code <span class="sort-indicator">{{ sortIndicator('events', 'name') }}</span></th>
              <th class="sortable" (click)="toggleSort('events', 'name')">Event Name <span class="sort-indicator">{{ sortIndicator('events', 'name') }}</span></th>
              <th class="sortable" (click)="toggleSort('events', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('events', 'entries') }}</span></th>
              <th class="sortable" (click)="toggleSort('events', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('events', 'exits') }}</span></th>
              <th class="sortable" (click)="toggleSort('events', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('events', 'internal') }}</span></th>
              <th class="sortable" (click)="toggleSort('events', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('events', 'reentries') }}</span></th>
              <th class="sortable" (click)="toggleSort('events', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('events', 'inVenue') }}</span></th>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.events.length">
                <th class="reject-col reject-pct-col sortable" (click)="toggleSort('events', '__rejectPct')">Reject % <span class="sort-indicator">{{ sortIndicator('events', '__rejectPct') }}</span></th>
                <th class="reject-col reject-total-col sortable"
                  [class.expanded]="rejectsExpanded.events"
                  title="Click to {{ rejectsExpanded.events ? 'hide' : 'show' }} reject breakdown">
                  <span class="reject-total-label" (click)="toggleSort('events', '__rejectTotal'); $event.stopPropagation()">
                    Rejects
                    <span class="sort-indicator">{{ sortIndicator('events', '__rejectTotal') }}</span>
                  </span>
                  <span class="reject-toggle-arrow" (click)="toggleRejectsExpanded('events'); $event.stopPropagation()">
                    {{ rejectsExpanded.events ? '▾' : '▸' }}
                  </span>
                </th>
                <ng-container *ngIf="rejectsExpanded.events">
                  <th class="reject-col sortable" *ngFor="let code of rejectColumnsByTable.events"
                    (click)="toggleSort('events', '__reject:' + code)">
                    {{ formatErrorCode(code) }} <span class="sort-indicator">{{ sortIndicator('events', '__reject:' + code) }}</span>
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of sortedEventKeysCache">
              <td class="primary-cell">{{ key }}</td>
              <td class="primary-cell">
                <a [href]="attendanceSummary.events[key].url">{{ attendanceSummary.events[key].name }}</a>
              </td>
              <td>{{ attendanceSummary.events[key].entries }}</td>
              <td>{{ attendanceSummary.events[key].exits }}</td>
              <td>{{ attendanceSummary.events[key].internal }}</td>
              <td>{{ attendanceSummary.events[key].reentries }}</td>
              <td>{{ attendanceSummary.events[key].inVenue }}</td>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.events.length">
                <td class="reject-col reject-pct-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.events[key].rejects)">
                  {{ rejectPercent(attendanceSummary.events[key]) | number: '1.0-2' }}%
                </td>
                <td class="reject-col reject-total-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.events[key].rejects)">
                  {{ rejectTotal(attendanceSummary.events[key].rejects) }}
                </td>
                <ng-container *ngIf="rejectsExpanded.events">
                  <td class="reject-col" *ngFor="let code of rejectColumnsByTable.events"
                    [class.is-zero]="!rejectCount(attendanceSummary.events[key].rejects, code)">
                    {{ rejectCount(attendanceSummary.events[key].rejects, code) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container *ngIf="entranceGroupTable !== undefined">
      <ng-container *ngIf="showGroup">
        <div class="extended-summary-table-wrapper" [class.dark]="useModernView && useDarkMode">
          <table class="extended-summary-table" id="groupTable">
            <thead>
              <tr>
                <th class="sortable" (click)="toggleSort('groupedEntries', 'name')">Grouped Entrance Name <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'name') }}</span></th>
                <th class="sortable" (click)="toggleSort('groupedEntries', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'entries') }}</span></th>
                <th class="sortable" (click)="toggleSort('groupedEntries', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'exits') }}</span></th>
                <th class="sortable" (click)="toggleSort('groupedEntries', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'internal') }}</span></th>
                <th class="sortable" (click)="toggleSort('groupedEntries', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'reentries') }}</span></th>
                <th class="sortable" (click)="toggleSort('groupedEntries', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'inVenue') }}</span></th>
                <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.groupedEntries.length">
                  <th class="reject-col reject-pct-col sortable" (click)="toggleSort('groupedEntries', '__rejectPct')">Reject % <span class="sort-indicator">{{ sortIndicator('groupedEntries', '__rejectPct') }}</span></th>
                  <th class="reject-col reject-total-col sortable"
                    [class.expanded]="rejectsExpanded.groupedEntries"
                    title="Click to {{ rejectsExpanded.groupedEntries ? 'hide' : 'show' }} reject breakdown">
                    <span class="reject-total-label" (click)="toggleSort('groupedEntries', '__rejectTotal'); $event.stopPropagation()">
                      Rejects
                      <span class="sort-indicator">{{ sortIndicator('groupedEntries', '__rejectTotal') }}</span>
                    </span>
                    <span class="reject-toggle-arrow" (click)="toggleRejectsExpanded('groupedEntries'); $event.stopPropagation()">
                      {{ rejectsExpanded.groupedEntries ? '▾' : '▸' }}
                    </span>
                  </th>
                  <ng-container *ngIf="rejectsExpanded.groupedEntries">
                    <th class="reject-col sortable" *ngFor="let code of rejectColumnsByTable.groupedEntries"
                      (click)="toggleSort('groupedEntries', '__reject:' + code)">
                      {{ formatErrorCode(code) }} <span class="sort-indicator">{{ sortIndicator('groupedEntries', '__reject:' + code) }}</span>
                    </th>
                  </ng-container>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let key of sortedGroupedKeysCache">
                <td class="primary-cell">{{ key }}</td>
                <td>{{ attendanceSummary.groupedEntries[key].entries }}</td>
                <td>{{ attendanceSummary.groupedEntries[key].exits }}</td>
                <td>{{ attendanceSummary.groupedEntries[key].internal }}</td>
                <td>{{ attendanceSummary.groupedEntries[key].reentries }}</td>
                <td>{{ groupedInside[key] }}</td>
                <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.groupedEntries.length">
                  <td class="reject-col reject-pct-col"
                    [class.is-zero]="!rejectTotal(attendanceSummary.groupedEntries[key].rejects)">
                    {{ rejectPercent(attendanceSummary.groupedEntries[key]) | number: '1.0-2' }}%
                  </td>
                  <td class="reject-col reject-total-col"
                    [class.is-zero]="!rejectTotal(attendanceSummary.groupedEntries[key].rejects)">
                    {{ rejectTotal(attendanceSummary.groupedEntries[key].rejects) }}
                  </td>
                  <ng-container *ngIf="rejectsExpanded.groupedEntries">
                    <td class="reject-col" *ngFor="let code of rejectColumnsByTable.groupedEntries"
                      [class.is-zero]="!rejectCount(attendanceSummary.groupedEntries[key].rejects, code)">
                      {{ rejectCount(attendanceSummary.groupedEntries[key].rejects, code) }}
                    </td>
                  </ng-container>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="showSummary">
      <div class="extended-summary-table-wrapper" [class.dark]="useModernView && useDarkMode">
        <table class="extended-summary-table" id="summaryTable">
          <thead>
            <tr>
              <th class="sortable" (click)="toggleSort('childVenues', 'name')">Venue Name <span class="sort-indicator">{{ sortIndicator('childVenues', 'name') }}</span></th>
              <th class="sortable" (click)="toggleSort('childVenues', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('childVenues', 'entries') }}</span></th>
              <th class="sortable" (click)="toggleSort('childVenues', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('childVenues', 'exits') }}</span></th>
              <th class="sortable" (click)="toggleSort('childVenues', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('childVenues', 'internal') }}</span></th>
              <th class="sortable" (click)="toggleSort('childVenues', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('childVenues', 'reentries') }}</span></th>
              <th class="sortable" (click)="toggleSort('childVenues', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('childVenues', 'inVenue') }}</span></th>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.childVenues.length">
                <th class="reject-col reject-pct-col sortable" (click)="toggleSort('childVenues', '__rejectPct')">Reject % <span class="sort-indicator">{{ sortIndicator('childVenues', '__rejectPct') }}</span></th>
                <th class="reject-col reject-total-col sortable"
                  [class.expanded]="rejectsExpanded.childVenues"
                  title="Click to {{ rejectsExpanded.childVenues ? 'hide' : 'show' }} reject breakdown">
                  <span class="reject-total-label" (click)="toggleSort('childVenues', '__rejectTotal'); $event.stopPropagation()">
                    Rejects
                    <span class="sort-indicator">{{ sortIndicator('childVenues', '__rejectTotal') }}</span>
                  </span>
                  <span class="reject-toggle-arrow" (click)="toggleRejectsExpanded('childVenues'); $event.stopPropagation()">
                    {{ rejectsExpanded.childVenues ? '▾' : '▸' }}
                  </span>
                </th>
                <ng-container *ngIf="rejectsExpanded.childVenues">
                  <th class="reject-col sortable" *ngFor="let code of rejectColumnsByTable.childVenues"
                    (click)="toggleSort('childVenues', '__reject:' + code)">
                    {{ formatErrorCode(code) }} <span class="sort-indicator">{{ sortIndicator('childVenues', '__reject:' + code) }}</span>
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr class="totals-row">
              <td class="primary-cell">All Venues Total</td>
              <td>{{ attendanceSummary.entries }}</td>
              <td>{{ attendanceSummary.exits }}</td>
              <td>{{ attendanceSummary.internal }}</td>
              <td>{{ attendanceSummary.reentries }}</td>
              <td>{{ attendanceSummary.inVenue }}</td>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.childVenues.length">
                <td class="reject-col reject-pct-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.rejects)">
                  {{ rejectPercent(attendanceSummary) | number: '1.0-2' }}%
                </td>
                <td class="reject-col reject-total-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.rejects)">
                  {{ rejectTotal(attendanceSummary.rejects) }}
                </td>
                <ng-container *ngIf="rejectsExpanded.childVenues">
                  <td class="reject-col" *ngFor="let code of rejectColumnsByTable.childVenues"
                    [class.is-zero]="!rejectCount(attendanceSummary.rejects, code)">
                    {{ rejectCount(attendanceSummary.rejects, code) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
            <tr *ngFor="let child of sortedChildVenueKeysCache">
              <td class="primary-cell">{{ child }}</td>
              <td>{{ attendanceSummary.childVenues[child].entries }}</td>
              <td>{{ attendanceSummary.childVenues[child].exits }}</td>
              <td>{{ attendanceSummary.childVenues[child].internal }}</td>
              <td>{{ attendanceSummary.childVenues[child].reentries }}</td>
              <td>{{ attendanceSummary.childVenues[child].inVenue }}</td>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.childVenues.length">
                <td class="reject-col reject-pct-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.childVenues[child].rejects)">
                  {{ rejectPercent(attendanceSummary.childVenues[child]) | number: '1.0-2' }}%
                </td>
                <td class="reject-col reject-total-col"
                  [class.is-zero]="!rejectTotal(attendanceSummary.childVenues[child].rejects)">
                  {{ rejectTotal(attendanceSummary.childVenues[child].rejects) }}
                </td>
                <ng-container *ngIf="rejectsExpanded.childVenues">
                  <td class="reject-col" *ngFor="let code of rejectColumnsByTable.childVenues"
                    [class.is-zero]="!rejectCount(attendanceSummary.childVenues[child].rejects, code)">
                    {{ rejectCount(attendanceSummary.childVenues[child].rejects, code) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container *ngIf="showTicket">
      <div class="extended-summary-table-wrapper" [class.dark]="useModernView && useDarkMode">
        <ng-container *ngIf="date > '2024-01-01' && displayData">
          <button class="extended-summary-download-btn" type="button" (click)="getASTATFile($event)">
            Download Ticket Type Report (CSV)
          </button>
        </ng-container>
        <table class="extended-summary-table">
          <thead>
            <tr>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'database')">Database <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'database') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'event')">Event <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'event') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'name')">Event Name <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'name') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'ticketType')">Ticket Type <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'ticketType') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'entries') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'exits') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'internal') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'reentries') }}</span></th>
              <th class="sortable" (click)="toggleSort('ticketTypes', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'inVenue') }}</span></th>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.ticketTypes.length">
                <th class="reject-col reject-pct-col sortable" (click)="toggleSort('ticketTypes', '__rejectPct')">Reject % <span class="sort-indicator">{{ sortIndicator('ticketTypes', '__rejectPct') }}</span></th>
                <th class="reject-col reject-total-col sortable"
                  [class.expanded]="rejectsExpanded.ticketTypes"
                  title="Click to {{ rejectsExpanded.ticketTypes ? 'hide' : 'show' }} reject breakdown">
                  <span class="reject-total-label" (click)="toggleSort('ticketTypes', '__rejectTotal'); $event.stopPropagation()">
                    Rejects
                    <span class="sort-indicator">{{ sortIndicator('ticketTypes', '__rejectTotal') }}</span>
                  </span>
                  <span class="reject-toggle-arrow" (click)="toggleRejectsExpanded('ticketTypes'); $event.stopPropagation()">
                    {{ rejectsExpanded.ticketTypes ? '▾' : '▸' }}
                  </span>
                </th>
                <ng-container *ngIf="rejectsExpanded.ticketTypes">
                  <th class="reject-col sortable" *ngFor="let code of rejectColumnsByTable.ticketTypes"
                    (click)="toggleSort('ticketTypes', '__reject:' + code)">
                    {{ formatErrorCode(code) }} <span class="sort-indicator">{{ sortIndicator('ticketTypes', '__reject:' + code) }}</span>
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of sortedTicketTypesCache">
              <td class="primary-cell">{{ item.database }}</td>
              <td class="primary-cell">{{ item.event }}</td>
              <td class="primary-cell"><a [href]="item.url">{{ item.name }}</a></td>
              <td class="primary-cell">{{ item.ticketType }}</td>
              <td>{{ item.entries }}</td>
              <td>{{ item.exits }}</td>
              <td>{{ item.internal }}</td>
              <td>{{ item.reentries }}</td>
              <td>{{ item.inVenue }}</td>
              <ng-container *ngIf="(ticketmaster | async) && rejectColumnsByTable.ticketTypes.length">
                <td class="reject-col reject-pct-col"
                  [class.is-zero]="!rejectTotal(item.rejects)">
                  {{ rejectPercent(item) | number: '1.0-2' }}%
                </td>
                <td class="reject-col reject-total-col"
                  [class.is-zero]="!rejectTotal(item.rejects)">
                  {{ rejectTotal(item.rejects) }}
                </td>
                <ng-container *ngIf="rejectsExpanded.ticketTypes">
                  <td class="reject-col" *ngFor="let code of rejectColumnsByTable.ticketTypes"
                    [class.is-zero]="!rejectCount(item.rejects, code)">
                    {{ rejectCount(item.rejects, code) }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container *ngIf="showTimedEntries && (timedGateEntries.length || timedScannerEntries.length)">
      <div class="dropdown-multiselect">
        <br />

        <div class="gate-dropdown">
          <div class="dropdown-header" (click)="toggleDropdown()">
            <span class="header-text">Select Gates</span>
            <span class="arrow">{{ dropdownOpen ? '▲' : '▼' }}</span>
          </div>


          <div class="dropdown-body" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">

            <!-- SEARCH -->
            <input class="search-box" type="text" placeholder="Search gates..." (keyup)="filterGates($event)" />

            <!-- SELECT ALL / DESELECT ALL -->
            <div class="dropdown-actions">
              <button class="dropdown-action-btn" (click)="selectAll('gates')">Select All</button>
              <button class="dropdown-action-btn" (click)="deselectAll('gates')">Deselect All</button>
            </div>

            <!-- OPTIONS -->
            <div class="dropdown-option" *ngFor="let gate of filteredGateEntries">
              <label>
                <input type="checkbox" [checked]="selectedGates.includes(gate.gate)"
                  (change)="toggleGateSelection(gate.gate)" />
                <span class="gate-label">{{ gate.gate }}</span>
              </label>
            </div>

          </div>
        </div>
      </div>

      <div *ngIf="selectedGates.length" style="margin-top: 20px; overflow-x: auto;">
  <table class="timed-entries-table">
    <thead>
      <tr>
        <th class="gate-column">Gate</th>
        <th *ngFor="let i of fifteenMinIndices" class="time-column">
          {{ timedGateEntries[0].formattedTimestamps[i] }}
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let gate of timedGateEntries">
        <tr *ngIf="selectedGates.includes(gate.gate)">
          <td class="gate-column"><strong>{{ gate.gate }}</strong></td>
          <td *ngFor="let i of fifteenMinIndices" class="time-column">
            {{ gate.entries[i] }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

    </ng-container>


    <ng-container *ngIf="showGraph && (timedGateEntries.length || timedScannerEntries.length)">
     <div class="graph-section" [class.dark]="useModernView && useDarkMode">
      <div class="graph-tabs" role="tablist">
        <button class="graph-tab" type="button" role="tab"
          [class.active]="activeGraphTab === 'gate'"
          [attr.aria-selected]="activeGraphTab === 'gate'"
          (click)="activeGraphTab = 'gate'">Gate</button>
        <button class="graph-tab" type="button" role="tab"
          [class.active]="activeGraphTab === 'scanner'"
          [attr.aria-selected]="activeGraphTab === 'scanner'"
          (click)="activeGraphTab = 'scanner'">Scanner</button>
      </div>
      <div class="graph-tab-panel" *ngIf="activeGraphTab === 'gate'">
          <button class="graph-download-btn" type="button" (click)="downloadTimedGateEntries()">Download File</button>

          <br />
          <div class="dropdown-multiselect">
            <br />
            <div class="gate-dropdown">
              <div class="dropdown-header" (click)="toggleDropdown()">
                <span class="header-text">Select Gates</span>
                <span class="arrow">{{ dropdownOpen ? '▲' : '▼' }}</span>
              </div>

              <div class="dropdown-body" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">
                <input class="search-box" type="text" placeholder="Search gates..." (keyup)="filterGates($event)" />

                <div class="dropdown-actions">
                  <button class="dropdown-action-btn" (click)="selectAll('gates')">Select All</button>
                  <button class="dropdown-action-btn" (click)="deselectAll('gates')">Deselect All</button>
                </div>

                <div class="dropdown-option" *ngFor="let gate of filteredGateEntries">
                  <label>
                    <input type="checkbox" [checked]="selectedGates.includes(gate.gate)"
                      (change)="toggleGateSelection(gate.gate)" />
                    <span class="gate-label">{{ gate.gate }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="checkbox-container">
        <div class="checkbox-item" *ngFor="let gate of timedGateEntries">
          <input type="checkbox"
                 [value]="gate.gate"
                 (change)="toggleGateSelection(gate.gate)"
                 [checked]="selectedGates.includes(gate.gate)">
          <label>{{ gate.gate }}</label>
        </div>
        </div> -->




          <div *ngIf="timedGateEntries.length" class="chart-container"
            style="position: relative; height: 100%; width: 100%;">
            <canvas baseChart [datasets]="gateChartData.datasets" [labels]="gateChartData.labels"
              [options]="chartOptions" type="line">
            </canvas>
          </div>
          <div>
          </div>
      </div>

      <div class="graph-tab-panel" *ngIf="activeGraphTab === 'scanner'">
          <button class="graph-download-btn" type="button" (click)="downloadTimedScannerEntries()">Download File</button>
          <br />



          <div class="dropdown-multiselect">
            <br />
            <div class="gate-dropdown">
              <div class="dropdown-header" (click)="toggleScannerDropdown()">
                <span class="header-text">Select Scanners</span>
                <span class="arrow">{{ scannerDropdownOpen ? '▲' : '▼' }}</span>
              </div>

              <div class="dropdown-body" *ngIf="scannerDropdownOpen" (click)="$event.stopPropagation()">
                <input class="search-box" type="text" placeholder="Search scanners..." (keyup)="filterScanners($event)" />

                <div class="dropdown-actions">
                  <button class="dropdown-action-btn" (click)="selectAll('scanners')">Select All</button>
                  <button class="dropdown-action-btn" (click)="deselectAll('scanners')">Deselect All</button>
                </div>

                <div class="dropdown-option" *ngFor="let scanner of filteredScannerEntries">
                  <label>
                    <input type="checkbox" [checked]="selectedScanners.includes(scanner.gate)"
                      (change)="toggleScannerSelection(scanner.gate)" />
                    <span class="gate-label">{{ scanner.gate }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="timedScannerEntries.length" class="chart-container"
            style="position: relative; height: 100%; width: 100%;">
            <canvas baseChart [datasets]="scannerChartData.datasets" [labels]="scannerChartData.labels"
              [options]="chartOptions" type="line">
            </canvas>
          </div>
          <div>
          </div>
      </div>
     </div>
    </ng-container>
    <ng-container *ngIf="ticketmaster">
      <p>Average Ingestion Time: {{latency}}</p>
    </ng-container>
  </ng-container>
  <!-- <ng-container *ngIf="currentDate <= date && !sessions">
    <tm1-button (click) = "newSession($event)">Create New Session</tm1-button>
</ng-container> -->

  <br />
  <br />
</div>